(function () {
  function find(scope, selector) {
    return scope ? scope.querySelector(selector) : null;
  }

  function updateSimpleCard(card, key, kind) {
    if (!card) return;

    var url = card.dataset[key + 'Url'];
    var price = card.dataset[key + 'Price'];
    var compare = card.dataset[key + 'Compare'];
    var prefix = card.dataset[key + 'Prefix'];
    var spec = card.dataset[key + 'Spec'];
    var detail = card.dataset[key + 'Detail'];
    var featurePrimary = card.dataset[key + 'FeaturePrimary'];

    var photoLink = find(card, '[data-' + kind + '-photo-link]');
    var prefixEl = find(card, '[data-' + kind + '-prefix]');
    var compareEl = find(card, '[data-' + kind + '-compare]');
    var priceEl = find(card, '[data-' + kind + '-price]');
    var specEl = find(card, '[data-' + kind + '-spec]');
    var detailEl = find(card, '[data-' + kind + '-detail]');
    var featurePrimaryEl = find(card, '[data-' + kind + '-feature-primary]');
    var ctaEl = find(card, '[data-' + kind + '-cta]');

    if (photoLink && url) photoLink.href = url;
    if (prefixEl) prefixEl.textContent = prefix || '';
    if (compareEl) {
      if (compare) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
    if (priceEl && price) priceEl.textContent = price;
    if (specEl) specEl.textContent = spec || '';
    if (detailEl) detailEl.textContent = detail || '';
    if (featurePrimaryEl && featurePrimary) featurePrimaryEl.textContent = featurePrimary;
    if (ctaEl && url) ctaEl.href = url;
  }

  function updateProCard(card, key) {
    if (!card) return;

    var img = find(card, '[data-pro-img]');
    var photoLink = find(card, '[data-pro-photo-link]');
    var nameEl = find(card, '[data-pro-name]');
    var specEl = find(card, '[data-pro-spec]');
    var weightEl = find(card, '[data-pro-weight]');
    var compareEl = find(card, '[data-pro-compare]');
    var priceEl = find(card, '[data-pro-price]');
    var ctaEl = find(card, '[data-pro-cta]');
    var ctaLabel = find(card, '[data-pro-cta-label]');

    var url = card.dataset[key + 'Url'];
    var src = card.dataset[key + 'Img'];
    var price = card.dataset[key + 'Price'];
    var compare = card.dataset[key + 'Compare'];
    var spec = card.dataset[key + 'Spec'];
    var weight = card.dataset[key + 'Weight'];
    var label = key === 'road' ? 'Small' : 'Medium';

    if (img && src) {
      img.style.opacity = '0';
      window.setTimeout(function () {
        img.src = src;
        img.alt = 'Bikeflip Box Pro ' + label;
        img.style.opacity = '1';
      }, 120);
    }

    if (photoLink && url) photoLink.href = url;
    if (nameEl) nameEl.textContent = label;
    if (specEl) specEl.textContent = spec || '';
    if (weightEl) weightEl.textContent = weight || '';
    if (compareEl) {
      if (compare) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
    if (priceEl && price) priceEl.textContent = price;
    if (ctaEl && url) ctaEl.href = url;
    if (ctaLabel) ctaLabel.textContent = key === 'road' ? 'Shop Pro Small' : 'Shop Pro Medium';

    card.querySelectorAll('[data-pro-tab]').forEach(function (button) {
      button.setAttribute('aria-selected', button.dataset.proTab === key ? 'true' : 'false');
    });
  }

  function applyVariant(section, key) {
    updateSimpleCard(find(section, '[data-basic-card]'), key, 'basic');
    updateProCard(find(section, '[data-pro-card]'), key);
    updateSimpleCard(find(section, '[data-go-card]'), key, 'go');
  }

  document.querySelectorAll('.cyb-section').forEach(function (section) {
    var defaultKey = section.dataset.cybDefault === 'road' ? 'road' : 'mtb';

    section.querySelectorAll('[data-pro-tab]').forEach(function (button) {
      button.addEventListener('click', function () {
        applyVariant(section, button.dataset.proTab);
      });
    });

    applyVariant(section, defaultKey);
  });
})();
